/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import React from "react";
import { IDisplayableField } from "../../Interfaces/IDisplayableField";
import { IAccessControlDetailProps } from "./IAccessControlDetailProps";

const accessControlFields = [
  {
    name: "id",
    label: "ID",
    type: "number",
  },
  {
    name: "firstName",
    label: "First Name",
    type: "text",
  },
  {
    name: "lastName",
    label: "Last Name",
    type: "text",
  },
  {
    name: "email",
    label: "Email",
    text: "text",
  },
  {
    name: "role",
    label: "Role",
    type: "date",
  },
  {
    name: "region",
    label: "Region",
    type: "text",
  },
  {
    name: "status",
    label: "Status",
    type: "text",
  },
  {
    name: "modifiedDate",
    label: "Last Modified",
    type: "date",
  },
] as IDisplayableField[];

class AccessControlDetails extends React.Component<IAccessControlDetailProps> {
  render(): React.ReactElement<IAccessControlDetailProps> {
    return (
      <>
        <p>This will be the access control details component.</p>
      </>
    );
  }
}

export default AccessControlDetails;
